<template>
  <v-app :theme="theme">
    <v-main>
      <router-view :useDisplaySize="useDisplaySize" />
    </v-main>
  </v-app>
</template>

<script>
import { useDisplay } from "vuetify/lib/framework.mjs";
import { getCurrentUser } from "aws-amplify/auth";
export default {
  name: "App",

  data: () => ({
    useDisplaySize: {},
    theme: "light",
  }),
  mounted() {
    this.useDisplaySize = useDisplay();
  },
  methods: {
    async getCurrentUsermethod() {
      try {
        const { username, userId, signInDetails } = await getCurrentUser();
        signInDetails.username = username;
        signInDetails.userId = userId;
        return {
          status: "SUCCESS",
          data: { ...signInDetails },
        };
      } catch (error) {
        return {
          status: "ERROR",
          data: error.message,
        };
      }
    },
  },
};
</script>

<style>
.fontVariant1 {
  font-family: "Poppins", sans-serif;
  font-size: 25px;
  color: #6c757d !important;
  font-weight: 600;
}

.fontVariant2 {
  font-family: "Poppins", sans-serif;
  font-size: 22px;
  color: #000000 !important;
  font-weight: 500;
}

.fontVariant3 {
  font-family: "Poppins", sans-serif;
  font-size: 18px;
  color: #000000 !important;
  font-weight: 500;
}

.fontVariant4 {
  font-family: "Poppins", sans-serif;
  font-size: 16px;
  color: #000000 !important;
  font-weight: 500;
}

.fontVariant5 {
  font-family: "Poppins", sans-serif;
  font-size: 14px;
  color: #000000 !important;
  font-weight: 500;
}

.fontVariant6 {
  font-family: "Poppins", sans-serif;
  color: #000000 !important;
  font-size: 12px;
  font-weight: 500;
}

.app-bar-color {
  background-color: #e5e0f8 !important;
}

.page-background-color {
  background-color: rgb(241, 241, 241);
}

.nav-drawer-tool-bar-color {
  background-color: #ebe1e3 !important;
}

.vdataTablescroll .v-data-table__wrapper::-webkit-scrollbar {
  width: 10px;
  height: 8px;
  background-color: #e6e6e6;
}
.vdataTablescroll ::-webkit-scrollbar-thumb {
  background: #b0b0b0 !important;
  border: solid 2px #e6e6e6 !important;
  border-radius: 7px !important;
}
.cardGradient {
  background-image: linear-gradient(to right, #8534e8, #86c4e1) !important;
}
.cardGradient1 {
  background-image: linear-gradient(to right, #8534e8, #86c4e1) !important;
}
.cardBorderColor {
  border: 1px solid white !important;
  background: none !important;
}
.PrimaryFontColor {
  color: #6c757d;
  font-size: 20px;
}

.fontSize12px {
  font-size: 12px !important;
}
.FontSize {
  font-size: 12px !important;
}
.fontSizeSmall {
  font-size: 10px !important;
}
.fontSizeXSmall {
  font-size: 9px !important;
}

.fontSize8px {
  font-size: 8px !important;
}

.fontSize9px {
  font-size: 9px !important;
}

.fontSize10px {
  font-size: 10px !important;
}
.fontSize11px {
  font-size: 11px !important;
}

.fontSize12px {
  font-size: 12px !important;
}
.fontSize14px {
  font-size: 14px !important;
}
.fontSize16px {
  font-size: 16px !important;
}

.fontSize18px {
  font-size: 18px !important;
}

.fontSize20px {
  font-size: 20px !important;
}
.fontSize15px {
  font-size: 15px !important;
}

.fontSize25px {
  font-size: 25px !important;
}

.fontSize35px {
  font-size: 35px !important;
}
.maxWidthSmall {
  max-width: 180px !important;
}
.maxWidthXSmall {
  max-width: 150px !important;
}
.maxWidthXXSmall {
  width: 120px !important;
}
.maxWidthXXXSmall {
  width: 100px !important;
}
.maxWidthSelect1 {
  max-width: 200px !important;
}
.maxWidthSelect2 {
  max-width: 150px !important;
}
.maxWidthSelect {
  max-width: 250px !important;
}

.maxWidthSelect3 {
  max-width: 300px !important;
}

.maxWidthSearch {
  max-width: 250px !important;
}
.borderVariant1 {
  border: 2px solid #8534e8 !important;
}
.borderVariant2 {
  border: 1px solid #000000 !important;
}
.v-input .v-label {
  font-size: 12px;
}
.field_height.v-text-field.v-input_control.v-input_slot {
  min-height: 12px !important;
  display: flex !important;
  align-items: center !important;
}
.field_label_size.v-input .v-label {
  font-size: 12px;
}
.text-field-border-color {
  color: rgb(176, 176, 176) !important;
}
.v-select .v-input_control .v-inputslot .v-selectslot .v-select_selections {
  padding: 0 !important;
  min-height: 0 !important;
}

.v-select-list .v-list-item {
  min-height: 30px !important;
}

.v-select-list .v-list-item .v-list-item__content {
  padding: 14px 0 !important;
}
.image-upload-input {
  display: none;
  z-index: -9999;
}
.greyColorVariantOne {
  background-color: #dad8d8 !important;
}
.redColorVariantOne {
  background-color: #fcbcbc !important;
}
.greenColorVariantOne {
  background-color: #c6ffd4 !important;
}
.audioPlayer {
  width: 100% !important;
  height: 50% !important;
}
.excel-upload-input {
  display: none;
  z-index: -9999;
}
/* .scroll-container .v-navigation-drawer__content {
  overflow: auto !important;
  scrollbar-width: none !important;
  scrollbar-color: transparent !important;
  display: none !important;
}
.scroll-container::-webkit-scrollbar {
  width: 0.1em !important;
}
.scroll-container::-webkit-scrollbar-track {
  background-color: red !important;
}
.scroll-container::-webkit-scrollbar-thumb {
  background-color: blue !important;
} */
.small-tab {
  padding: 4px 6px !important;
  font-size: 12px !important;
}

.custom-list-group .v-list-group__header {
  height: 24px !important; /* Adjust the height value as per your requirement */
}

.custom-list-group .v-list-item {
  height: 24px !important; /* Adjust the height value as per your requirement */
}

.cursorPointer {
  cursor: pointer !important;
}

.container {
  min-height: 100vh !important; /* Set minimum container height to 100% of viewport height */
  display: flex !important; /* Use flexbox to align card vertically */
}

.custom-scrollbar {
  overflow-y: auto !important;
  scrollbar-width: thin !important;
  scrollbar-color: #8534e8 #f5f5f5 !important;
}

.custom-scrollbar::-webkit-scrollbar {
  width: 8px !important;
}

.custom-scrollbar::-webkit-scrollbar-track {
  background: #f5f5f5 !important;
}

.custom-scrollbar::-webkit-scrollbar-thumb {
  background-color: #8534e8 !important;
  border-radius: 4px !important;
}

.custom-scrollbar::-webkit-scrollbar-thumb:hover {
  background-color: #8534e8 !important;
}

.scroll .v-data-table__wrapper::-webkit-scrollbar {
  width: 12px !important;
  height: 12px !important;
  background-color: #ffffff;
  color: red;
}
.scroll .v-data-table__wrapper::-webkit-scrollbar-thumb {
  background: #8534e8 !important;
  border: solid 3px #e6e6e6 !important;
  border-radius: 7px !important;
}

.full-height {
  height: 100vh !important;
}

.full-height-card {
  height: 100% !important;
}

.CustomizedTableClass table {
  border: 1px solid #f2f2f2 !important;
  border-collapse: collapse !important;
  border-radius: 10px !important;
  overflow: hidden !important;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.15) !important;
  margin: 0 auto !important;
}
.CustomizedTableClass table tr:nth-child(even) {
  background-color: #e5f6f0 !important;
}
.CustomizedTableClass table th {
  position: -webkit-sticky !important;
  top: 0 !important;
  z-index: 0 !important;
  background-color: white;
}
* {
  scrollbar-width: thin !important;
}

.tableClass table {
  border-collapse: collapse !important;
  margin-bottom: 15px !important;
  overflow: hidden !important;
  margin: 0 0 !important;
  /* border-collapse: separate;
  border-spacing: 0 4px !important;
  background: #ffffff00 !important; 
  background: #ffffff00 !important;
  border: 1px solid #E8E8E8;
  border-radius: 6px !important;
  border-collapse: separate !important;
  border-spacing: 0px !important;
  */
}
.tableClass th {
  height: 42px !important;
  color: #000000 !important;
  font-size: 12px !important;
  background-color: white !important;
}
.tableClass.v-table.v-table--fixed-header
  > .v-table__wrapper
  > table
  > thead
  > tr
  > th {
  position: -webkit-sticky !important;
  top: 0 !important;
  z-index: 0 !important;
  background-color: white !important;
  color: #242427 !important;
  font-size: 12px !important;
  font-weight: bold !important;
}
.tableClass.v-table
  > .v-table__wrapper
  > table
  > tbody
  > tr
  > td
  > .v-card-actions {
  min-height: 30px !important;
  padding: 1px !important;
  /* color: red !important; */
  font-size: 12px !important;
  /* border-bottom: 1px solid #e6e7e982 !important; */
}

.tableClass tr:nth-child(even) {
  background-color: #f2f2f2;
}

.tableClass td:first-child {
  border-left: 1px solid #e6e7e982 !important;
  border-bottom-left-radius: 6px !important;
}

.tableClass td:last-child {
  border-right: 1px solid #e6e7e982 !important;
  border-bottom-right-radius: 6px !important;
}
.tableClass2 table {
  border-collapse: separate;
  border-spacing: 0 4px !important;
  width: 280% !important;
}
.tableClass2 th {
  background: white !important;
  border: none !important;
  border-bottom: none !important;
  padding: 1px;
  color: #000000 !important;
  font-size: 12px !important;
}
.tableClass2 td {
  width: 200px !important;
  /* overflow: hidden !important; */
  white-space: nowrap !important;
  border-radius: 0px !important;
  padding: 0px;
}
.WebSticky {
  position: -webkit-sticky !important;
  position: sticky !important;
  top: 0 !important;
}
.expansionPanel .v-expansion-panel-content .v-expansion-panel-content__wrap {
  padding: 0 !important;
  flex: 1 1 auto;
  max-width: 100%;
}

.create-btn:hover {
  color: white !important;
  background-color: #2b4af6 !important;
}

.filter-btn {
  background-color: white;
  color: white !important;
  transition: background-color 0.3s;
}

.filter-btn:hover {
  background-color: white;
  color: #dc143b !important;
  transition: background-color 0.3s;
}

.delete-btn {
  background-color: #ffffff;
  color: #9a2835 !important;
  transition: background-color 0.3s;
}
.delete-btn:hover {
  color: white !important;
  background-color: #9a2835 !important;
}
.grey-border {
  border: 1px solid #e5e5e5 !important;
}
.iconCard {
  background-color: #f6f6f6 !important;
  border-radius: 20% !important;
}
.bgColor {
  background-color: #f4f5f7 !important;
}
.titleCard {
  font-size: 12px !important;
  color: #5042e5 !important;
  border-radius: 20% !important;
}
.btnCard {
  font-size: 12px !important;
  background-color: white !important;
  border-color: #e8e8e8 !important;
  border-radius: 20% !important;
}
.btnCard:hover {
  background-color: #3d928f !important;
  color: white !important;
}
.hiddenScrollbar {
  overflow: hidden !important;
}
</style>
